import type { KeyboardShortcutCommand } from '@tiptap/core';

import { Extension } from '@tiptap/core';

// ----------------------------------------------------------------------

export const ClearFormat = Extension.create({
  name: 'clearFormat',
  /********/
  addKeyboardShortcuts() {
    const clearFormatting: KeyboardShortcutCommand = ({ editor }) =>
      editor.chain().focus().clearNodes().unsetAllMarks().run();

    return {
      'Mod-Shift-X': clearFormatting,
    };
  },
});
